import { defineComponent as _defineComponent } from 'vue'
import TableWithActions from '@/components/tableWithActions/TableWithActions.vue';
import { AlertOccurrence } from '@/models/alertOccurrence';
import {
  matchesDateGrouping,
  matchesEventCode,
  matchesEventSource,
  matchesMetric,
  matchesOperator,
  matchesThreshold,
  matchesVariable,
  formatWithUnit,
  translateKpi,
  translateOperator,
} from '@/utils/alerts';
import { translateDateGrouping } from '@/utils/dates';
import { isEmpty } from '@/utils/misc';
import { matchIgnoringCase } from '@/utils/table';
import { useI18n } from '@/composables/i18n';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AlertOccurrencesTable',
  props: {
    alertOccurrences: null,
    rowsPerPage: { default: 20 },
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { alertOccurrences: AlertOccurrence[] | null, rowsPerPage: number, loading: boolean };



const { t } = useI18n();

function alertHasSources(alertOccurrence: AlertOccurrence): boolean {
  return !isEmpty(alertOccurrence.eventSources);
}

function alertHasCodes(alertOccurrence: AlertOccurrence): boolean {
  return !isEmpty(alertOccurrence.eventCodes);
}

function additionalInformationSearch(
  alertOccurrence: AlertOccurrence,
  input: string,
) {
  return (
    matchesVariable(alertOccurrence, input) ||
    matchesEventSource(alertOccurrence, input) ||
    matchesEventCode(alertOccurrence, input) ||
    (alertOccurrence.variable &&
      matchIgnoringCase(
        t('report.alert_occurrences_table.variable').toString(),
        input,
      )) ||
    (alertOccurrence.eventSources &&
      matchIgnoringCase(
        t('report.alert_occurrences_table.event_sources').toString(),
        input,
      )) ||
    (alertOccurrence.eventCodes &&
      matchIgnoringCase(
        t('report.alert_occurrences_table.event_codes').toString(),
        input,
      ))
  );
}

const alertOccurrencesData = computed<AlertOccurrence[]>(
  () => props.alertOccurrences ?? [],
);

return { __sfc: true,props, t, alertHasSources, alertHasCodes, additionalInformationSearch, alertOccurrencesData, TableWithActions, matchesDateGrouping, matchesMetric, matchesOperator, matchesThreshold, formatWithUnit, translateKpi, translateOperator, translateDateGrouping }
}

})